<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      :id="`input-shipping_address_zip_code`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractSignupTextInput from "../core/AbstractSignupTextInput";
import BaseInputMixin from "@/mixins/signupInputMixin";
import InputWidget from "@/components/core/InputWidget.vue";

export default {
  name: "ShippingZipCode",
  components: {InputWidget, AbstractSignupTextInput},
  mixins: [BaseInputMixin('shipping_address.zip_code')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'shipping_address.zip_code',
      defaultLabel: this.$t("Zip Code")
    }
  }
}
</script>

<style scoped>

</style>
